import { QueryClient } from "@tanstack/react-query";

import { logOnDev } from "@/services/axios/interceptors/response";

import { PusherUpdateEventData } from "../../types";
import { baseOrganisationChannelUpdateFn } from "./base-organisation-channel-update-fn";

export const clientOrganisationChannelUpdateFn = (
  queryClient: QueryClient,
  data: PusherUpdateEventData
) => {
  logOnDev("[‼️][CLIENT UPDATE EVENT]", data);
  baseOrganisationChannelUpdateFn(queryClient, data);
};
